module.exports = require("supports-webp");